// External Dependencies
import 'jquery';
import 'bootstrap';
window.bootstrap = require('bootstrap/dist/js/bootstrap.bundle.js');

// Import common & others
import common from "./common";

$(document).ready(() => {
    common.init();
});
